import React from 'react'
import './inputs.css'


export const TextInput = ({dark, className, setRef, setType, ...others}) => {
  const classNames = ['textinput']
  if (dark) {
    classNames.push('textinput--dark')
  }
  if (className) {
    classNames.push(className)
  }
  const ref = {ref:setRef ? setRef : null}

  return (
    <input
      className={classNames.join(' ')}
      {...ref}
      {...others}
    />
  )

}

export const TextArea = ({dark, className, setRef, setType, ...others}) => {
  const classNames = ['textinput', 'textarea']
  if (dark) {
    classNames.push('textinput--dark')
  }
  if (className) {
    classNames.push(className)
  }
  const ref = {ref:setRef ? setRef : null}

  return (
    <textarea
      className={classNames.join(' ')}
      {...ref}
      {...others}
    />
  )

}



// WEBPACK FOOTER //
// ./src/core/components/input/index.js